<template>
	<div id="repositorybox">
			<!--主题内容第三部分-->
			<div   class="repository_subject">
				<div class="subject_lift">
					
					<ul class="subject_lift_1">
					<h4>分类</h4>
						<li class="subject_lift_btn" v-for="item in repositoryCateList" @click="applyKnowledge(item.vc_catalogcode,$event)">{{item.vc_catalogname}}({{item.count}})</li>
					</ul>
				</div>
				<div id="repository_nodata" class="subject_middle">
					<!--搜索第一部分-->
			<div class="upper">
					<span class="searchwrap">
						<input type="text" placeholder="搜索知识库"  v-model="repositorySearch"/>
						<a style="cursor: pointer;" @click="resetsearch" v-if="repositorySearch"  class="el-icon-thirdicon-qingchu"></a>
					</span>
					<span @click="search" style="cursor: pointer;" class="btn el-icon-search" >
					</span>
			</div>
			<!--排序第二部分-->
			<div class="ranking">
				<div class="two_1" v-if="contentShow">
					<h4 >找到<span style="color: #076BF2;">{{repositoryCountArr[repositoryCate]}}个</span>资料</h4>
				</div>
				<div class="ranking_right">
					<span class="sortbytime el-icon-thirdicon-daoxu" style="cursor: pointer;" @click.stop="sortbytime($event)">
							时间
						</span>
						<span class="sortbyhot el-icon-thirdicon-daoxu" style="cursor: pointer;" @click.stop="sortbyhot($event)">
							热度
						</span>
				</div>

			</div>
			<div class="line">
				<hr style="height:2px;border:none;border-top:2px solid #DDDDDD;" />
			</div>
			
			<!-- 显示数据开始 -->
			<div style="overflow: hidden;"  v-for="item in repositoryListArr[repositoryCate]" @click="jumpRepositoryDetail(item.vc_contentcode,item.n_contenttype,item.content)">
				<!-- <h1>{{item.dt_createtime}}----{{item.vc_page_view}}-------{{item.n_stick}}</h1> -->
					<!-- 单张大图 -->
					<div style="cursor: pointer;" class="chunk" v-if="item.n_photo_type == '1'">
						<div class="subject_middle_1">
							<h4>{{item.vc_title}}</h4>
						</div>
						<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
						<div class="subject_middle_picture" v-if="item.vc_coverphoto">
								<img  class="subject_middle_picture" :src="apiUrl+item.vc_coverphoto" />
						</div>
					</div>
					
					<!-- 多张小图 -->
					<div class="chunk2" style="cursor: pointer;" v-if="item.n_photo_type == 2">
						<div class="subject_middle_6">
							<h4 >{{item.vc_title}}</h4>
							<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
							
							<div  v-for="i in item.vc_coverphoto.split(',')" class="subject_middle_5" v-if="i">
								<img class="subject_middle_picture3" :src="apiUrl+i" />
							</div>
						</div>
					</div>
					
					
					<!-- 单张小图 -->
					<div class="chunk1" style="cursor: pointer;" v-if="item.n_photo_type == 3">
						<div class="subject_middle_2" v-if="item.vc_coverphoto">
							<img class="subject_middle_picture2" :src="apiUrl+item.vc_coverphoto" />
							<div class="videomark" v-if="item.n_is_video=='1'">
								<i class="el-icon-thirdicon-play_icon" style="color: white;"></i>
							</div>
						</div>
						<div class="subject_middle_3" v-if="item.vc_coverphoto">
							<h4 >{{item.vc_title}}</h4>
							<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
						</div>
						<div class="subject_middle_6" v-if="!item.vc_coverphoto">
							<h4 >{{item.vc_title}}</h4>
							<div class="content_abstract" v-if="item.vc_abstract"><span v-if="item.vc_create_time">{{item.vc_create_time}}-</span>{{item.vc_abstract}}</div>
						</div>
					</div>
					
				</div>
				<div id="repository_none" v-if='has_nodata'>
					<img src="../assets/images/none.png"/>
						<!--<h3>暂无数据</h3>-->
				</div>
				<div class="graph_show_more" v-if="contentShow&&graph_m_b">
					<span v-if="repositoryMoreArr[repositoryCate]" @click="more" class="graph-morebtn"><span class="el-icon-thirdicon-gengduo-copy"></span>查看更多</span>
					<span v-if="!repositoryMoreArr[repositoryCate]">没有更多数据了</span>
				</div>
			</div>
			</div>
	</div>
</template>

<script>
	import '@/router/jquery-3.3.1.min.js'
	export default {
		data() {
			return {
				has_nodata:false,
				apiUrl:this.apiUrl,
				graph_m_b:false,
				contentlistnum:'',
				isclearshow:'',
				repositorySearch:'',		//搜索条件
				contentShow:false,					//是否显示
				repositoryCateList:'',		//目录列表
				repositoryCate:'',					//当前选中目录
				repositoryListArr:new Array(),		//内容列表数组
				repositoryPageArr:new Array(),		//页码数据
				repositoryMoreArr:new Array(),		//是否还有数据数组
				repositoryCountArr:new Array(),		//图片数量数组
				repositorySortArr:new Array(),		//排序方式数组
				scrollTop:new Array(),				//滚动条到页面顶部的距离
				scrollHeight:new Array(),			//内容高度
			}
		},
		mounted(){
			let _this=this;
			window.scrollTo(0,0);
			//获取分类列表
			this.$http.get(
				_this.apiUrl+'index.php? m=Api&c=Content&a=repositoryCate'
			).then(response => {
				
				//进行数据验证
				if(response.body.status != 1){
					
					//显示错误页面
//					alert('请求错误');
					return;
				}
				
				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
					
//					alert('没有数据');
//					_this.common.dataValidation('repository_nodata',600)
					return;
				}
				
				//目录赋值
				this.repositoryCateList = response.body.data;
				
				//临时数据
				var temporaryList = [];
				var temporaryPage = [];
				var temporaryMore = [];
				var temporaryCount = [];
				var temporarySort = [];
				
				Object.keys(response.body.data).forEach(function(key){
					temporaryList[response.body.data[key]['vc_catalogcode']] = '';
					temporaryPage[response.body.data[key]['vc_catalogcode']] = 1;
					temporaryMore[response.body.data[key]['vc_catalogcode']] = true;
					temporaryCount[response.body.data[key]['vc_catalogcode']] = '0';
					temporarySort[response.body.data[key]['vc_catalogcode']] = 'time';
				})
				
				//内容列表/页码/是否还有数据
				this.repositoryListArr = temporaryList;
				this.repositoryPageArr = temporaryPage;
				this.repositoryMoreArr = temporaryMore;
				this.repositoryCountArr = temporaryCount;
				this.repositorySortArr = temporarySort;
				
				//当前选中目录
				this.repositoryCate = this.repositoryCateList[0].vc_catalogcode;
				
				//获取列表数据
				this.queryData();
				
			}, response => {
//				alert('请求错误');
			});
			
		},
		 beforeRouteLeave(to, from, next) {
        	from.meta.keepAlive = false;
       		 next();
		},
		methods:{
			//左侧导航栏   点击事件
			applyKnowledge(uuid,event) {
				this.resetsearch();
				//获取当前分类的内容高度和滚动条到顶部的距离
//				this.scrollTop[this.repositoryCate] = this.getScrollTop();
//				this.scrollHeight[this.repositoryCate] = document.body.scrollHeight;
				
				window.scrollTo('0','0');
				// alert(this.scrollTop[this.repositoryCate] )
				$(event.target).siblings('li').css({'background': '#fff','color':'black'})
				event.target.style.background='#076bf2'
				event.target.style.color='white'

				this.repositoryCate = uuid;

				if(this.repositorySortArr[this.repositoryCate] == 'hot'){
					let time = document.getElementsByClassName('sortbytime')[0]
					let hot = document.getElementsByClassName('sortbyhot')[0]
					hot.style.color = 'white'
					hot.style.background = '#076BF2'
					time.style.color = '#818181';
					time.style.background = 'none'
				}else{
					
					let hot = document.getElementsByClassName('sortbyhot')[0]
					let time = document.getElementsByClassName('sortbytime')[0]
					time.style.color = 'white'
					time.style.background = '#076BF2'
					hot.style.color = '#818181';
					hot.style.background = 'none'
				}
				this.queryData('1');

				//设置当前分类的高度和滚动条到顶部的距离
//				document.getElementsByTagName('body')[0].style.height = this.scrollHeight[uuid]+'px';  //robin 2018 11 28 22:59
//				window.scrollTo(0,this.scrollTop[uuid]);
			},
			// 搜索栏清除内容
			resetsearch() {
				this.repositorySearch=''
			},
			sortbytime(event) {
				let hot = document.getElementsByClassName('sortbyhot')[0]
				event.target.style.color = 'white'
				event.target.style.background = '#076CF2'
				hot.style.color = '#818181';
				hot.style.background = 'none'
				
				//时间排序
				this.repositorySortArr[this.repositoryCate] = 'time';
				this.contentShow = false;
				this.repositoryListArr[this.repositoryCate].sort(this.compare("dt_createtime"));
				
				this.contentShow = true;
			},
			sortbyhot(event) {
				let time = document.getElementsByClassName('sortbytime')[0]
				event.target.style.color = 'white'
				event.target.style.background = '#076CF2'
				time.style.color = '#818181';
				time.style.background = 'none'
				
				//热度排序
				this.repositorySortArr[this.repositoryCate] = 'hot';
				this.contentShow = false;
				this.repositoryListArr[this.repositoryCate].sort(this.compare("vc_page_view"));
				this.contentShow = true;
			},
			
			//搜索
			search(){

				var temporaryMore = [];
				var temporaryPage = [];
				var temporaryList = [];
				var repositoryCateList = this.repositoryCateList;
				Object.keys(repositoryCateList).forEach(function(key){
					temporaryMore[repositoryCateList[key]['vc_catalogcode']] = true;
					temporaryPage[repositoryCateList[key]['vc_catalogcode']] = 1;
					temporaryList[repositoryCateList[key]['vc_catalogcode']] = '';
				})
				this.repositoryMoreArr = temporaryMore;		//显示查看更多
				this.repositoryPageArr = temporaryPage;			//页码重新设置为1
				this.repositoryListArr = temporaryList;
				this.queryData('1');			//查询数据
			},
			
			//查看更多
			more(){
				this.repositoryPageArr[this.repositoryCate]++;		//页码加一
				this.queryData('2');			//查询数据
			},
			
			//获取数据方法 1为列表切换 2为查看下一页
			queryData(type){
				let _this=this;
				this.has_nodata=false;
				this.contentShow = false;
				if(type == '1' && this.repositoryListArr[this.repositoryCate] != ''){
					this.contentShow = true;
//					if(this.repositoryListArr[this.repositoryCate].length>11){
					for (let i =0;i<this.repositoryCateList.length;i++) {
						if(this.repositoryCateList[i].vc_catalogcode==this.repositoryCate){
							//当前选中目录
							this.repositoryCateList[i].count;
							if(this.repositoryPageArr[this.repositoryCate]*12<this.repositoryCateList[i].count){
								this.graph_m_b=true;
							}else{
								this.graph_m_b=false;
							}
						}
					}
					return false;
				}

				this.$http.get(
					_this.apiUrl+'index.php? m=Api&c=Content&a=repositoryList',
					{
						params: {  
							"page":this.repositoryPageArr[this.repositoryCate],
							"cateUuid":this.repositoryCate,
							"keyword":this.repositorySearch
						}  
					}
				).then(response => {
					for (let i =0;i<this.repositoryCateList.length;i++) {
						if(this.repositoryCateList[i].vc_catalogcode==this.repositoryCate){
							//当前选中目录
							this.repositoryCateList[i].count;
							if(this.repositoryPageArr[this.repositoryCate]*12<this.repositoryCateList[i].count){
								this.graph_m_b=true;
							}else{
								this.graph_m_b=false;
							}
						}
					}	

//					if(response.body.data.rep_list.length>11){
	/*if(this.repositoryPageArr[this.repositoryCate]*12<this.repositoryListArr['count']){
						this.graph_m_b=true;
					}else{
						this.graph_m_b=false;
					}*/

					//进行数据验证
					if(response.body.status != 1){
						
						//显示错误页面
//						alert('请求错误');
						return;
					}
					
					if(typeof response.body.data.rep_list == "undefined" || response.body.data.rep_list == null || response.body.data.rep_list == ""){
						
						//判断是否请求第一页的数据
						if(this.repositoryPageArr[this.repositoryCate] == 1){
							
							//显示空数据页面
//							alert('没有数据');
//							_this.common.dataValidation('repository_nodata',600)
							this.has_nodata=true;
						}else{
							
							//显示没有数据
							this.repositoryMoreArr[this.repositoryCate] = false;
							this.contentShow = true;
							this.has_nodata=false;
						}
						return;
					}
					
					//判断是否是第一次请求
					if(this.repositoryListArr[this.repositoryCate] == '' && this.repositoryPageArr[this.repositoryCate] == 1){
						
						//直接赋值
						this.repositoryListArr[this.repositoryCate] = response.body.data.rep_list;
						this.contentlistnum=response.body.data.rep_list;
						
//						if((this.contentlistnum.length%12)>0){
//							this.graph_m_b=false;
//						}
//						else{
//							this.graph_m_b=true;
//						}
					}else{
						
						//合并数据
						this.repositoryListArr[this.repositoryCate] = this.repositoryListArr[this.repositoryCate].concat(response.body.data.rep_list);
						this.contentlistnum=this.repositoryListArr[this.repositoryCate];
					}
					
				
					this.repositoryCountArr[this.repositoryCate] = response.body.data.count;
					
					this.contentShow = true;
					
				}, response => {
//					alert('请求错误');
				});
			},
			
			//排序(降序)
			compare(prop) {
				return function (obj1, obj2) {
						if(obj1['n_stick'] == '1'){
							return -1;
						}
						var val1 = obj1[prop];
						var val2 = obj2[prop];
						if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
								val1 = Number(val1);
								val2 = Number(val2);
						}
						if (val1 > val2) {
								return -1;
						} else if (val1 < val2) {
								return 1;
						} else {
								return 0;
						}            
				} 
			},
			
			//跳转详情或者外链
			jumpRepositoryDetail(uuid,type,url){
				if(type == 2){
					window.open(url);
				}else{
					this.$router.push({
						path: 'repository1',
						query: {
							uuid: uuid
						}
					})
				}
				
			},

			//获取滚动条到顶部的距离
			getScrollTop(){    
			    var scrollTop=0;    
			    if(document.documentElement&&document.documentElement.scrollTop){    
			        scrollTop=document.documentElement.scrollTop;    
			    }else if(document.body){    
			        scrollTop=document.body.scrollTop;    
			    }    
			    return scrollTop;    
			} 
 		}
	}
</script>

<style>
	#repository_none{
		width: 100%;
		height: 500px;
	}
	#repository_none>img{
		display: block;
		margin: 100px auto;
	}
	.graph_show_more{
		width: 100%;height: 100px;line-height: 100px;float: left;
	}
	#repositorybox{
		/*margin-top: 70px;*/
		background-color: #FFFFFF;
	}
	.searchwrap {
		width: 826px;
		height: 54px;
		/*margin-top: 25px;*/
		display: block;
		line-height: 54px;
		float: left;
		
	}
	.searchwrap>input{
		width: 95%;
		height: 54px;
		outline: none;
		border: 0;
		margin: 0;
		float: left;
		font-size: 16px;
		text-indent: 1em;
		overflow: hidden;
	}
	.searchwrap>a{
		width: 5%;
		height: 100%;
		display: block;
		float: right;
		font-size: 24px;
		line-height: 54px;
	}
	.upper>.btn {
		font-size: 30px;
		display:block;
		width: 122px;
		height: 54px;
		background-color: #076BF2;
		line-height: 54px;
		float: right;
		color: white;
		margin-top: -1px;
		margin-right: -1px;
		border: 1px solid #076BF2;
	}
	
	.btn_1 {
		width: 80px;
		height: 30px;
		line-height: 30px;
		background-color: #076BF2;
	    color: white;
	}
	
	.btn_2 {
		width: 80px;
		height: 30px;
		line-height: 30px;
		background-color: white;
	}
	
	.upper {
		width: 100%;
		height: 54px;
		margin: 0 auto;
		margin-top: 48px;
		margin-bottom: 30px;
		border: 1px solid #9E9E9E;
		border-radius: 4px;
		overflow: hidden;	
	}
	.upper .el-icon-search{
		height: 54px!important;
		line-height: 54px!important;
	}
	.upper1 {
		width: 60%;
		height: 85px;
		float: left;
		background-color: #f3f3f3;
		text-align: left;
	}
	
	.ranking {
		width: 950px;
		height: 45px;
		margin: 0 auto;
		margin-bottom: 10px;
	}
	
	
	.two_1 {
		width: 50%;
		height: 45px;
		float: left;
		text-align: left;
	}
	.two_1>h4{
		font-size: 22px;
		/*cursor: pointer;*/
	}
	.ranking_right{
		height: 35px;
		float: right;
		border-radius: 3px;
		overflow: hidden;
		border: 1px solid #D1D1D1;
	}
	.ranking_right>span{
		width: 88px;
		height: 35px;
		line-height: 35px;
		display: block;
		float: left;
	
	}
	.line {
		width: 950px;
		height: 10px;
		margin: 0 auto;
	}
	/**主体*/
	.repository_subject {
		box-sizing: border-box;
		width: 1200px;
		/*min-height: 969px;*/
		margin: 0 auto;
		overflow: hidden;
	}
	.subject_lift {
		margin-top: 42px;
		width: 250px;
		height:calc(100% - 151px);
		float: left;
		background-color: white;
		overflow: hidden;
	}
	
	.subject_lift_1 {
		width: 220px;
		height: calc(100% - 181px);
		float: left;
		border-style: solid;
		border-width: 1px;
		border-color: #F3F3F3;
		border-radius: 7px;
		position: fixed;
		margin-top: 10px;
		background-color: white;
		overflow-y: hidden;

	}
	
	.subject_lift_1>h4 {
		width: 100%;
		height: 30px;
		line-height: 30px;
		margin-top: 20px;
		color: #333;
		font-size: 18px;
	}
	.subject_middle_1>h4{
		text-align: left; margin-top: 10px;font-size: 20px;color: #222222;font-weight: 500;
	}
	.subject_middle_3>h4{
		line-height: 60px;text-align: left;font-size: 20px;color: #232322;font-weight: 500;
	}
	.subject_lift_btn {
		list-style: none;
		width: 80%;
		height: 36px;
		line-height: 36px;
		margin: 20px 20px 0 20px;
		border-radius: 18px;
		border: none;
		outline: none;
		cursor: pointer;
		background-color: #FFFFFF;
	}
	.subject_lift_1 li:nth-of-type(1){
		color: white;
		/*background: -webkit-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -o-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -moz-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: linear-gradient(30deg, #65d2ff , #076bf2);*/
	   background: #076bf2;
	}
	/**块*/
	
	.chunk {
		width: 100%;
		/*height: 427px;*/
		float: left;
	}
	.chunk1 {
		width: 100%;
		/*height: 150px;*/
		float: left;
	}
	
	.chunk2 {
		width: 100%;
		/*height: 231px;*/
		float: left;
	}
	
	.content_abstract{
		overflow: hidden;
		height: 48px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		text-align: left;
		line-height: 24px;
		font-size: 14px;
		color: #999999;
	}
	.subject_middle {
		margin-top: 30px;
		width: 950px;
		/*height: 100%;*/
		min-height: 900px;
		float: left;
		margin-bottom: 100px;
		background-color: white;
	}
	
	.subject_middle_picture {
		width: 100%;
		height: 380px;
		background-size: 100% 100%;
	}
	.subject_middle_picture>img{
		width: 100%;
		height: 380px;
		display: block;
	}
	.subject_middle_1 {
		width: 100%;
		height: 34px;
	}
	
	.subject_middle_2 {
		width: 218px;
		height: 140px;
		float: left;
		margin-top: 10px;
		position: relative;
	}
	.subject_middle_2>.videomark{
		width: 200px;
		height: 120px;
		position: absolute;
		top: 0;
		left: 0;
		line-height: 120px;
		background: rgba(0,0,0,0.6);
	}
	.videomark>.el-icon-thirdicon-play_icon{
		height: 120px;
		line-height: 120px;
		display: inline-block;
		font-size: 36px;
	}
	.subject_middle_picture2 {
		width: 200px;
		height: 120px;
		float: left;
		background-size: 100% 100%;
	}
	.subject_middle_picture3 {
		width: 310px;
		height: 120px;
		float: left;
		background-size: 100% 100%;
	}
	
	.subject_middle_3 {
		width: 75%;
		height: 140px;
		float: left;
		margin-top: 10px;
	}
	
	.subject_middle_4 {
		width: 100%;
		height: 140px;
		float: left;
	}
	
	.subject_middle_6 {
		width: 100%;
		/*height: 140px;*/
		float: left;
		/*overflow: hidden;*/
	}
	.subject_middle_6>h4{
		text-align: left;font-size: 20px;color: #222222;font-weight: 500;line-height: 60px;
	}
	.subject_middle_5 {
		width: 33%;
		height: 140px;
		float: left;
		margin-top: 12px;
		margin-right: 3px;
	}
	.a{
		background-color: #000000;
	}
	
	
	.sortbytime{
  	float: left;
  	line-height: 35px;
  	color: white;
  	display: block;
  	width: 97px;
  	height: 35px;
  	background: #076CF2;
  }
  .sortbyhot{
  	float: right;
  	line-height: 35px;
  	color: #818181;
  	display: block;
  	width: 97px;
  	height: 35px;
  }
  
  .sortbytime {
		float: left;
		line-height: 35px;
		color: white;
		display: block;
		width: 97px;
		height: 35px;
		background: #076CF2;
	}
	
	.sortbyhot {
		float: right;
		line-height: 35px;
		color: #818181;
		display: block;
		width: 98px;
		height: 35px;
		background: ;
	}
	.graph-morebtn{
		cursor: pointer;
		background-color: #fff;
		border: 0 solid #fff;
		color: #057FF1;
	}
</style>


// WEBPACK FOOTER //
// src/register/repositoryPage.vue